import { Slide } from "@material-ui/core";
import React from "react";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));
export default Transition;
